module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAAAXNSR0IArs4c6QAAAIhJREFUKBWN0T0OgCAMBWBoQpgcPYWnMEwsHEQPyOgpPIWTm0zIYyAS+evA9LW0eYw1Sms9K6U2EF5zQM65w3u/ENFehF/EOT+llOsPlpC19spgDWU7tlCCPRThCAIkPCMVjxmZmq7u4QTxfQtnsIV/sIaLVyOymG/IOTTeQogHA6qFnY0xE8ALxiuQZFdj+4EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart6-icon/arrow_right_m.png
// module id = 1297
// module chunks = 7